import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetProsjektProcessByIdQuery } from '@klp/prosjekt/services/rtkApi';

import { Main } from '@klp/layout';

import { ProsjektSammendrag } from '../components/ProsjektSammendrag/ProsjektSammendrag';
import { Grid } from '@material-ui/core';
import { Loader } from '@klp/design/Loader';
import { ProsjektRoutes } from '../config';

export const ProsjektSammendragView = () => {
    const { i18n } = useTranslation();
    const { prosjektId, prosessInstansId } = useParams<{
        prosjektId: string;
        prosessInstansId: string;
    }>();

    const { data, isLoading, isFetching, isError } =
        useGetProsjektProcessByIdQuery({
            prosjektId,
            culture: i18n.language,
        });

    if (isError) {
        return (
            <ProsjektSammendrag
                prosjektId={prosjektId}
                prosessInstansId={prosessInstansId}
            >
                <ProsjektSammendrag.Error />
            </ProsjektSammendrag>
        );
    }

    return (
        <ProsjektSammendrag
            prosjektId={prosjektId}
            prosessInstansId={prosessInstansId}
        >
            <Main>
                <Main.Breadcrumbs>
                    <Main.Crumb
                        id="projectschema"
                        label="breadcrumbs.project.schema"
                        href={ProsjektRoutes.projectSchema()}
                    />
                    <Main.Crumb
                        id="prosjektnavn"
                        label={data?.navn ?? undefined}
                    />
                </Main.Breadcrumbs>
                <Main.Navigation>
                    <ProsjektSammendrag.Navigation />
                </Main.Navigation>
                <Grid container={true} spacing={2}>
                    <Grid item={true} xs={12}>
                        <ProsjektSammendrag.Title />
                    </Grid>
                    <Grid item={true} xs={12}>
                        <ProsjektSammendrag.ProjectActions />
                    </Grid>
                    <Grid item={true} xs={12}>
                        <ProsjektSammendrag.Stepper />
                    </Grid>
                    <Grid item={true} xs={12}>
                        <ProsjektSammendrag.AvvistKommentar />
                    </Grid>
                    <Grid item={true} xs={12} md={9} lg={9}>
                        <Loader isLoading={isLoading || isFetching}>
                            <ProsjektSammendrag.Table />
                        </Loader>
                    </Grid>
                    <Grid item={true} xs={12} md={3} lg={3}>
                        <ProsjektSammendrag.ProcessActions />
                    </Grid>
                </Grid>
            </Main>
        </ProsjektSammendrag>
    );
};
